
























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class UField extends Vue {
  @Prop({ default: "" })
  public vname!: string;

  @Prop({ default: "aggressive" })
  public mode!: string;

  @Prop({ default: "" })
  public rules!: string;

  @Prop({ default: "" })
  public vid!: string;

  @Prop({ default: "" })
  public label!: string;

  @Prop({ default: false })
  public expanded!: boolean;

  @Prop({ default: false })
  public grouped!: boolean;

  @Prop({ default: false })
  public showSuccess!: boolean;

  @Prop({ default: true })
  public showErrorMessage!: boolean;

  @Prop({ default: true })
  public slim!: boolean;
}
